<template>
  <v-container v-if="!wizardStore.showAllOptions" max-width="1100px" class="pt-4">
    <div class="text-center mb-6">
      <h1 class="mb-0"><span>🎉</span>{{ $t('rollOffWizard.result.perfectMatch') }}</h1>
      <p class="mb-0">{{ $t('rollOffWizard.result.builtForYou') }}</p>
    </div>
    <v-row justify="center">
      <v-col cols="12" md="4" class="d-flex justify-center">
        <v-card class="pa-6" outlined>
          <div class="font-weight-bold mb-1" style="font-size:1.15rem;">{{ $t(wizardStore.selectedProduct?.titleKey) }}</div>
          <div class="mb-0" style="font-size:1rem;color:#444;">{{ $t(wizardStore.selectedProduct?.sizeKey) }}</div>
          <div class="d-flex justify-center">
            <v-img :src="wizardStore.selectedProduct?.image" :alt="$t(wizardStore.selectedProduct?.titleKey)" style="width:250px;height:auto;margin:8px 0 12px 0;" />
          </div>
          <div class="mt-1">
            <div class="font-weight-bold" style="font-size:1.05rem;line-height: 1;">
              <strong>{{ $t(wizardStore.selectedProduct?.descritionKey) }}</strong><br/>
              <span class="font-weight-regular" style="font-size:0.98rem;color:#444;">{{ $t(wizardStore.selectedProduct?.descrition2Key) }}</span>
            </div>
            <div class="font-weight-bold mt-1" style="font-size:1rem;color:#222;margin-bottom:8px;">{{ $t(wizardStore.selectedProduct?.materialKey) }}</div>
            <div class="d-flex justify-start align-center" style="gap:8px;">
              <v-icon color="#0a417a" v-for="(icon, i) in wizardStore.selectedProduct?.icons" :key="i">
                {{ icon }}
              </v-icon>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

  <!-- Show all options selected -->
  <v-container v-else max-width="1100px" class="pt-4">
    <div class="text-center mb-6">
      <h1 class="mb-0">{{ $t('rollOffWizard.result.otherOptions') }}</h1>
      <p class="mb-0">{{ $t('rollOffWizard.result.allAvailableContainers') }}</p>
    </div>
    <v-row>
      <v-col
        v-for="(option, k) in wizardStore.districtProducts"
        :key="k"
        cols="12"
        md="4"
        lg="3"
        class="d-flex justify-center"
      >
        <v-card
          class="pa-6 d-flex flex-column option-card border-2-point-5"
          :class="wizardStore.selectedProduct?.title === option.title ? 'border-primary' : 'border'"
          :style="wizardStore.selectedProduct?.title === option.title ? 'border-color:#0b6f52' : ''"
          outlined
          @click="wizardStore.selectProductByIndex(k)"
        >
          <div class="font-weight-bold mb-1" style="font-size:1.15rem;">{{ $t(option.titleKey) }}</div>
          <div class="mb-0" style="font-size:1rem;color:#444;">{{ $t(option.sizeKey) }}</div>
          <div class="d-flex justify-center">
            <v-img class="no-drag" :src="option.image" :alt="$t(option.titleKey)" style="width:auto;height:140px;margin:8px 0 12px 0;" />
          </div>
          <div class="my-1">
            <div class="font-weight-bold" style="font-size:1.05rem;line-height: 1;">
              <strong>{{ $t(option.descritionKey) }}</strong><br/>
              <span class="font-weight-regular" style="font-size:0.98rem;color:#444;">{{ $t(option.descrition2Key) }}</span>
            </div>
            <div class="font-weight-bold mt-1" style="font-size:1rem;color:#222;margin-bottom:8px;">{{ $t(option.materialKey) }}</div>
          </div>
          <div class="d-flex justify-start align-center mt-auto" style="gap:8px;">
            <v-icon color="#0a417a" v-for="(icon, i) in option.icons" :key="i">
              {{ icon }}
            </v-icon>
          </div>
          <div class="result-radiobox">
            <v-icon v-if="wizardStore.selectedProduct?.title === option.title" color="success">mdi-radiobox-marked</v-icon>
            <v-icon v-else color="#bdbdbd">mdi-radiobox-blank</v-icon>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRollOffWizardStore } from '@/store/rollOffWizard'
import { useIndexStore } from '@/store/index'

const wizardStore = useRollOffWizardStore()
const indexStore = useIndexStore()

onMounted(() => {
  wizardStore.setAvailableProducts(indexStore.apiResultOriginal?.data?.ServicePackges)
  wizardStore.setRecommendedProduct()
});
</script>

<style scoped>
.result-radiobox {
  position: absolute;
  top: 18px;
  right: 18px;
  font-size: 1.5rem;
}
.option-card {
  cursor: pointer;
  min-height: 410px;
  border-radius: 16px;
  position: relative;
  transition: border 0.2s, box-shadow 0.2s;
}
.option-card:hover {
  border-color:#003F6F;
}
@media (max-width: 1100px) {
  .option-card {
    width: 95vw !important;
    min-width: 0;
    max-width: 400px;
  }
}
.no-drag{
  user-select: none; 
  user-drag: none;
  -webkit-user-drag: none;
  pointer-events: none;
}
</style>